module.exports = __webpack_public_path__ + "static/img/1.c54a2b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/1.png
// module id = hTOo
// module chunks = 0